import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerPlanConnectBrokerComponent } from './broker-plan-connect-broker.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [BrokerPlanConnectBrokerComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [BrokerPlanConnectBrokerComponent]
})
export class BrokerPlanConnectBrokerModule { }
